import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import NavCommon from '../../../components/navCommon';
import CardContainerCommon from '../../../components/cardCommon';
import InputCommon from '../../../components/inputCommon';
import RowInputCommon from '../../../components/rowInputsCommon';
import {
  ContainerPlus,
  Divider,
  Img,
  InputBox,
  Margin,
  MarginInput,
  MarginText,
  OnPress,
  Row,
  Space,
  Title,
} from './styles';
import InputFileCommon from '../../../components/inputFileCommon';
import icons from '../../../constants/icons';
import warn from '../../../constants/toast';
import axios from '../../../services/criterion';
import { Criterios } from '../../../interfaces';
import BackDrop from '../../../components/backDropCommon';

interface CriterionProps {
  criterion: Criterios;
}

const Variable = () => {
  const state = useLocation<CriterionProps>()?.state?.criterion;
  const toPush = { targetInicial: '', targetFinal: '', pontos: '' };
  const history = useHistory();
  const [photoBase64, setPhotoBase64] = useState<string>('');
  const [fileName, setNameFile] = useState<string>('');
  const [hasPhoto, setHasPhoto] = useState<boolean>(false);
  const [openDrop, setOpenDrop] = useState<boolean>(false);
  const [name, setName] = useState<string>('');
  const [nameError, setNameError] = useState<boolean>(false);
  const [description, setDescription] = useState<string>('');
  const [descriptionError, setDescriptionError] = useState<boolean>(false);
  const [benefitError, setBenefitError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [editMode, setEditMode] = useState<boolean>(false);
  const [benefitInput, setBenefitInput] = useState<Array<{
    targetInicial: string, targetFinal: string, pontos: string
  }>>([
    { targetInicial: '', targetFinal: '', pontos: '' },
  ]);

  useEffect(() => {
    populate();
  }, []);

  useEffect(() => {
    if (name) {
      setNameError(false);
    }
    if (description) {
      setDescriptionError(false);
    }
    if (benefitInput) {
      setBenefitError(false);
    }
  }, [photoBase64, name, description, benefitInput]);

  const populate = () => {
    if (state) {
      setEditMode(true);
      setHasPhoto(true);
      setName(state.nome);
      setDescription(state.descricao);
      setPhotoBase64(`data:image/png;base64,${state.iconeBase64}`);
      setBenefitInput(state.pontuacaoVariavel);
    }
  };

  const onChangeFrom = (value: any, index: string) => {
    if (value === '' || value >= '0') {
      setBenefitInput(benefitInput.map((item, it: number) => {
        if (it.toString() === index) {
          item.targetInicial = value;
          return item;
        }
        return item;
      }));
    }
  };
  const onChangeTo = (value: any, index: string) => {
    if (value === '' || value >= '0') {
      setBenefitInput(benefitInput.map((item, it: number) => {
        if (it.toString() === index) {
          item.targetFinal = value;
          return item;
        }
        return item;
      }));
    }
  };

  const onChangeEnd = (value: any, index: string) => {
    if (value === '' || value >= '0') {
      setBenefitInput(benefitInput.map((item, it: number) => {
        if (it.toString() === index) {
          item.pontos = value;
          return item;
        }
        return item;
      }));
    }
  };

  const remove = (key: string) => {
    if (benefitInput.length === 1) {
      return;
    }
    setBenefitInput(benefitInput.filter((item: any, index: number) => index.toString() !== key));
  };

  const cleanForm = () => {
    setPhotoBase64('');
    setNameFile('');
    setName('');
    setDescription('');
    setBenefitInput([]);
    setBenefitInput((() => [toPush]));
  };

  const validation = () => {
    if (!name || !description) {
      if (!name) {
        setNameError(true);
      }
      if (!description) {
        setDescriptionError(true);
      }
      for (let a = 0; a < benefitInput.length; a += 1) {
        if (!benefitInput[a].targetInicial
          || !benefitInput[a].targetFinal
          || !benefitInput[a].pontos) {
          setBenefitError(true);
          break;
        }
      }
      warn.wargingError('Atenção!\nInforme os dados!');
      return true;
    }
    return false;
  };

  function filterImg(img: String) {
    if (img.includes('jpeg')) {
      return img.replace('data:image/jpeg;base64,', '');
    }
    if (img.includes('png')) {
      return img.replace('data:image/png;base64,', '');
    }
    return '';
  }

  const newCriterion = async () => {
    try {
      if (validation()) {
        return;
      }
      setLoading(true);
      await axios.newCriterionVariable(
        name,
        description,
        false,
        filterImg(photoBase64),
        fileName,
        2,
        benefitInput,
      );
      cleanForm();
      setLoading(false);
      warn.wargingSuccess('Critério cadastrado com sucesso!');
    } catch (error: any) {
      setLoading(false);
      warn.wargingError(`${error?.response?.data?.notifications?.map((item: any) => `${item.message}\n`) || 'Erro status 500!'}`);
    }
  };

  const updateCriterion = async () => {
    try {
      if (validation()) {
        return;
      }
      setLoading(true);
      await axios.updateCriterionVaraible(
        state.idCriterio,
        name,
        description,
        false,
        filterImg(photoBase64),
        fileName,
        2,
        benefitInput,
      );
      setLoading(false);
      warn.wargingSuccess('Critério atualizado com sucesso!');
    } catch (error: any) {
      setLoading(false);
      warn.wargingError(`${error?.response?.data?.notifications?.map((item: any) => `${item.message}\n`) || 'Erro status 500!'}`);
    }
  };

  const Body = (): any => (
    <>
      {loading && (
      <BackDrop />
      )}
      <Row>
        <InputBox>
          <InputFileCommon
            hasPhoto={hasPhoto}
            setHasPhoto={setHasPhoto}
            onChange={setPhotoBase64}
            onChangeFileName={setNameFile}
            photo={photoBase64}
            isError={false}
          />
        </InputBox>
        <Space />
        <InputBox>
          <InputCommon
            isDisabled={false}
            isError={nameError}
            type="text"
            placeholder="Nome"
            value={name}
            onChange={setName}
          />
        </InputBox>
      </Row>
      <MarginInput>
        <InputBox>
          <InputCommon
            isDisabled={false}
            isError={descriptionError}
            type="text"
            placeholder="Descrição"
            value={description}
            onChange={setDescription}
          />
        </InputBox>
      </MarginInput>
      <MarginText>
        <Title>
          Pontuação
        </Title>
      </MarginText>
      <Divider />
      <MarginInput style={{ marginTop: -10 }}>
        {benefitInput.map((item: any, index: number) => (
          <>
            <Space />
            <RowInputCommon
              isError={benefitError}
              firstText="Até"
              secontText="Recebera"
              endText="Pontos"
              id={index.toString()}
              remove={remove}
              onChangeFrom={onChangeFrom}
              onChangeTo={onChangeTo}
              onChangeEnd={onChangeEnd}
              from={item.targetInicial}
              to={item.targetFinal}
              end={item.pontos}
            />
          </>
        ))}
      </MarginInput>
      <ContainerPlus>
        <OnPress onClick={() => {
          setBenefitInput((states) => [...states, toPush]);
        }}
        >
          <Img
            height={24}
            width={24}
            src={icons.plusGreenIcon}
          />
        </OnPress>
      </ContainerPlus>
      <Space />
    </>
  );
  return (
    <>
      <NavCommon
        isSave
        onSave={editMode ? updateCriterion : newCriterion}
        breadcrumbs={[
          { path: '/polipositions', name: 'Pole positions' },
          { path: '/criterios-poleposition', name: 'Critérios' },
          { path: '', name: 'Novo' },
          { path: '', name: 'Variável' },
        ]}
        showDrop={false}
        hasOnChange
        onBack={() => { history.goBack(); }}
        setOpen={setOpenDrop}
        open={openDrop}
        onChange={() => {}}
      />
      <Margin>
        <CardContainerCommon title={editMode ? 'Atualizar Critério' : 'Novo Critério'} childrens={Body()} hasFilter={false} />
      </Margin>
    </>
  );
};
export default Variable;
